import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';
import { useGLTF, useAnimations } from '@react-three/drei';
import { CapsuleCollider, RigidBody } from '@react-three/rapier';
import { useFrame } from '@react-three/fiber';

const Diver = React.memo(({ playerRef, targetRotationY }) => {
  const { scene, animations } = useGLTF("./models/diver.glb");
  const groupRef = useRef();
  const { actions, names } = useAnimations(animations, groupRef);

  useEffect(() => {
    if (actions?.[names[0]]) actions[names[0]].play();
  }, [actions, names]);

  // Smooth rotation of diver Y - face
  useFrame((_, delta) => {
    if (!groupRef.current) return;
    groupRef.current.rotation.y = THREE.MathUtils.lerp(groupRef.current.rotation.y,targetRotationY.current,4 * delta);});

  return (
    <RigidBody
      ref={playerRef}
      position={[0, 3, -10]}
      rotation={[-Math.PI / 7, Math.PI, 0]}
      gravityScale={0.3}
      linearDamping={4}
      angularDamping={1}
      colliders={false}
      enabledRotations={[false, false, false]} 
    >
      <CapsuleCollider args={[1.1, 1.1]} position={[0, 1.4, 0]} />
      <primitive object={scene} scale={0.5} ref={groupRef} />
    </RigidBody>
  );
});

export default Diver;
